import React from "react";
import * as PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import DCMTagMarker from "component/molecules/DCMTagMarker";

@inject("toolbarStore")
@inject("metadataStore")
@inject("gridLayoutStore")
@observer
class DCMTagMarkerContainer extends React.PureComponent {
  static defaultProps = {
    stack: "",
  };
  render() {
    const { metadataStore, toolbarStore } = this.props;
    const { stack, idx, isFocus, numImages, ...props } = this.props;
    //const numberOfFrames = metadataStore.getNumberOfFrames(this.props.stack);
    const isShow = toolbarStore.isShowDCMDescription();
    if (isShow === true) {
      return (
        <DCMTagMarker
          ref={this.props.innerRef}
          stack={stack}
          isFocus={isFocus}
          //numberOfFrames={numberOfFrames}
          numberOfFrames={numImages}
          {...props}
        />
      );
    } else {
      return "";
    }
  }
}
export default DCMTagMarkerContainer;
